class SettingsClient {
  setSettings(data) {
    const { localStorage } = window;
    localStorage.setItem("settings", JSON.stringify(data.body));
    return new SettingsClient();
  }

  get data() {
    return JSON.parse(localStorage.getItem("settings")) || {};
  }

  get conversationsEnabled() {
    return !!this.data.zendesk?.conversations_enabled;
  }

  clear() {
    localStorage.removeItem("settings");
  }
}

export default SettingsClient;
